<template>
    <div class="row" v-loading="isLoading">
        <div class="form-group col-12" v-for="v in document_template.custom_variables" :key="v.name">
            <label class="mb-0" :for="v.name + _uid">{{ v.title }}</label>
            <template v-if="v.type === 'text'">
                <input type="text" class="form-control" :name="v.name" :id="v.name + _uid" v-model="values[v.name]">
            </template>
            <template v-if="v.type === 'number'">
                <input type="number" class="form-control" :name="v.name" :id="v.name + _uid" v-model="values[v.name]" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) ||event.charCode == 44 || event.charCode == 46 || event.charCode == 0">
            </template>
            <template v-if="v.type === 'date'">
                <input type="date" class="form-control" :name="v.name" :id="v.name + _uid" v-model="values[v.name]">
            </template>
            <template v-if="v.type === 'company'">
                <CounteragentSelect v-model="values[v.name]" :filter_type="'company'" :filter_platforms="[deal.platform_id]" class="multiselect-bootstrap" :id="v.name + _uid"/>
            </template>
            <template v-if="v.type === 'person'">
                <CounteragentSelect v-model="values[v.name]" :filter_category="'other'" :filter_type="'person'" :filter_platforms="[deal.platform_id]" class="multiselect-bootstrap" :id="v.name + _uid"/>
            </template>
            <template v-if="v.type === 'staff'">
                <CounteragentSelect v-model="values[v.name]" :filter_category="'staff'" :filter_type="'person'" :filter_platforms="[deal.platform_id]" class="multiselect-bootstrap" :id="v.name + _uid"/>
            </template>
            <template v-if="v.type === 'profile'">
                <ProfileSelect v-model="values[v.name]" :request_id="deal.request_id" :id="v.name + _uid"/>
            </template>
        </div>
        <div class="form-group col-12 text-right">
            <button @click="apply" class="btn btn-light"><i class="fas fa-download mr-2"></i>Скачать документ</button>
        </div>
<!--        <div class="form-group col-6">-->
<!--            <label class="mb-0" :for="'salon_legal_entity_id' + _uid">Юрлицо площадки</label>-->
<!--            <CounteragentSelect v-model="salon_legal_entity_id" :filter_type="'company'" class="multiselect-bootstrap" :id="'salon_legal_entity_id' + _uid"/>-->
<!--            <div v-if="field_errors.hasOwnProperty('salon_legal_entity_id')" class="help-block invalid-feedback d-block" v-html="field_errors['salon_legal_entity_id'][0]"/>-->
<!--        </div>-->
<!--        <div class="form-group col-12 text-right">-->
<!--            <button @click="generate" class="btn btn-light"><i class="fas fa-download mr-2"></i>Скачать документ</button>-->
<!--        </div>-->
    </div>
</template>

<script>
import CounteragentSelect from "../counteragents/CounteragentSelect";
import ProfileSelect from "../requests/profiles/ProfileSelect";
export default {
    name: "DocumentForm",
    components: {ProfileSelect, CounteragentSelect},
    props: {
        deal: {
            type: Object,
            required: true,
        },
        document_template: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        values: {},
        isLoading: false,
    }),
    methods: {
        apply() {
            this.$emit('prepared', {id: this.document_template.id, values: this.values})
        }
    }
}
</script>

<style scoped>

</style>
